import { render, staticRenderFns } from "./ProcedureList.vue?vue&type=template&id=03980dbd&scoped=true&"
import script from "./ProcedureList.vue?vue&type=script&lang=js&"
export * from "./ProcedureList.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureList.vue?vue&type=style&index=0&id=03980dbd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03980dbd",
  null
  
)

export default component.exports